import { IgButton } from "@intelligems/ig-theme/IgButton";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Box, Stack, useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { useGetOrg } from "@src/api/organizations/get-organization";
import Logo from "@src/images/igLogo/logo_gem_white.png";

export const ShareLinkBanner = () => {
  const org = useGetOrg();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const noWrap = {
    color: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } as const;

  const body = isMobile ? (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <IgTypography
        sx={{
          ...noWrap,
        }}
      >
        <strong style={{ fontWeight: 700 }}>{org.data.org.name}'s</strong> test
        analytics
      </IgTypography>
    </Box>
  ) : (
    <Stack
      direction="row"
      sx={{
        flex: 1,
        justifyContent: "space-between",
        alignItems: "center",
        py: 3,
      }}
      spacing={1}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <IgTypography
          sx={{
            ...noWrap,
          }}
        >
          You're viewing{" "}
          <strong style={{ fontWeight: 700 }}>{org.data.org.name}'s</strong>{" "}
          test analytics — Want to explore your own tests? Try Intelligems free.
        </IgTypography>
      </Box>
      <IgButton
        color="secondary"
        onClick={() => window.open("https://intelligems.io", "_blank")}
      >
        Learn More
      </IgButton>
    </Stack>
  );

  return (
    <Stack
      direction="row"
      sx={{
        color: "white",
        background:
          "linear-gradient(28deg, rgba(66, 165, 245, 1) 0%, rgba(41, 98, 255, 1) 26%, rgba(21, 101, 192, 1) 89%)",
        paddingX: isMobile ? 2 : 8,
        paddingY: 1,
      }}
      alignItems="center"
      spacing={2}
    >
      <img
        src={Logo}
        alt="Intelligems Logo"
        style={{
          maxHeight: 30,
          height: "auto",
        }}
      />

      {body}
    </Stack>
  );
};
